import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DocumentSubType } from '../../../appconfig';
import { DocumentsService } from '../../services/common/documents.service';
import { FormGroup } from '@angular/forms';
import { CommonService } from '../../services/common/common.service';
import { IconList } from '../../../iconlist';
import { environment } from '../../../environments/environment';
import { SelectItemGroup } from 'primeng/api';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})

export class UserProfileComponent implements OnInit, OnChanges {
  @Input() userData: any
  @Input() context: any
  @Output() changeModalState = new EventEmitter<any>();
  @Output() edituserPanel = new EventEmitter<any>();
  @Output() editPaymentPanel = new EventEmitter<any>();
  userProfileImage: any = environment.assetsImagePath + IconList.DefaultUserProfilePic
  userProfilePicOperationIcon = environment.assetsImagePath + IconList.AddIcon
  userProfileData: any;

  userprofileForm!: FormGroup
  documentFileData: any;
  currentAddress: any;
  permanentAddress: any;
  displayDocumentPicDialogue: boolean = false
  receipt = false;

  groupedAssests!: SelectItemGroup[];
  selectedAssest: any | undefined;

  constructor(private documentService: DocumentsService, private commonService: CommonService) {
    this.groupedAssests = [
      {
        label: 'Nominee',
        value: 'nominee',
        items: [
          { label: 'Rohit Kumar', value: '1' }
        ]
      },
      {
        label: 'Emergency',
        value: 'emergency',
        items: [
          { label: 'Karan Gupta', value: '1' }
        ]
      },
      {
        label: 'Co-Applicant',
        value: 'coApplicant',
        items: [
          { label: 'Shivansh Suneja', value: '1' }
        ]
      },
      {
        label: 'Family Members',
        value: 'familymembers',
        items: [
          { label: 'Pardeep Singh', value: '1' }
        ]
      }
    ]
  }

  ngOnChanges(changes: SimpleChanges): void {
    //if current user's profile pic file is not blank then get its profile pic (if uploaded)
    if (this.userData?.profilePicfile)
      this.getCurrentUserProfilePic()

    //if current user is not blank then sets respective fields
    if (this.userData?.userProfileData) {
      this.userProfileData = this.userData?.userProfileData
      var currentData = this.userProfileData.addresses.find((ad: any) => ad.assressType?.name == "Current");
      var permanentData = this.userProfileData.addresses.find((ad: any) => ad.assressType?.name == "Permanent")
      if (currentData) {
        this.currentAddress = this.commonService.formateAddress((currentData.address1 ? (currentData.address1 + ',') : '') + (currentData.address2 ? (currentData.address2 + ',') : '') + (currentData.city.name ? currentData.city.name : '') + (currentData.pincode ? ('-' + currentData.pincode) : ''))
      }
      else if (permanentData) {
        this.permanentAddress = this.commonService.formateAddress((currentData.address1 ? (currentData.address1 + ',') : '') + (currentData.address2 ? (currentData.address2 + ',') : '') + (currentData.city.name ? currentData.city.name : '') + (currentData.pincode ? ('-' + currentData.pincode) : ''))
      }
    }
  }

  ngOnInit() {
    //Sets default pic for user profile and default icon (add Icon) for pic add operation
    this.setDefaultUserProilePic()
  }


  /**
   * Gets the profile pic of current user
   * @param userId user id whose profile pic details has to be fetched
   */
  getCurrentUserProfilePic() {
    //by defaults we assume file id does not exists
    if (this.userData?.profilePicfile) {
      this.documentFileData = this.userData?.profilePicfile
      //if any profile pic already uploaded for current user then get the pic bytes else set default pic
      this.documentService.getDocumentBytesById(this.userData?.profilePicfile?.documentId).subscribe((profilePicRes: any) => {
        //if we find the profile pic on cloude then it display it
        if (profilePicRes) {
          this.userProfileImage = this.commonService.BaseStringToNormalString(profilePicRes)
          this.userProfilePicOperationIcon = environment.assetsImagePath + IconList.EditIcon
        }
        else {
          //If document id exists but somehow pic deleted (in any case) from cloud then it will sent the default pic
          //but operatonit mode will be edit not add as file id already exists
          this.setDefaultUserProilePic()
        }
      })
    }
  }


  /**
   * Sets the default pics of user profile. Also, add icon by defalt for operation.
   */
  setDefaultUserProilePic() {
    this.userProfileImage = environment.assetsImagePath + IconList.DefaultUserProfilePic
    if (this.userData?.profilePicfile)
      this.userProfilePicOperationIcon = environment.assetsImagePath + IconList.EditIcon
    else
      this.userProfilePicOperationIcon = environment.assetsImagePath + IconList.AddIcon
  }


  /**
   * Sets the config for file to be uploaded
   * @param documentSubType
   */
  setCurrentFileConfig(documentSubType: any) {
    if (this.documentFileData) {
      this.documentFileData.picFor = this.commonService.addSpaceInCamelCase(documentSubType)
      this.documentFileData.showDocumentNumber = false
    }
    else {
      this.documentFileData = this.documentService.setDocumentFileDataConfig(this.userProfileData?.id, DocumentSubType[documentSubType],
        this.commonService.addSpaceInCamelCase(documentSubType), false)
    }

    this.displayDocumentPicDialogue = true;
  }


  /**
   * Show Communication Panel on  Communication Icon Click
   */
  communicationIconClick() {
    if (this.edituserPanel) {
      this.edituserPanel.emit({
        "showEditprofilePanel": false
      });
    }
    this.changeModalState.emit({
      "showCommunicationPanel": true
    });

  }

  // Recipt Fuctionality Show & Hide
  recieptClick() {
    if (this.edituserPanel) {
      this.edituserPanel.emit({
        "showEditprofilePanel": false
      });
    }
    this.editPaymentPanel.emit({
      "showReceipt": true
    })
  }

  /**
  * Editable Mode Data Show
  */
  editUserProfile() {
    // this.commonService.selectTab(0);
    if (this.changeModalState) {
      this.changeModalState.emit({
        "......": false
      });
    }

    this.edituserPanel.emit({
      "showEditprofilePanel": true,
      "customerData": this.userProfileData,
      "context": this.context
    });
  }


  /**
   * Receive currently uploaded file on file dialogue modal
   * @param receivedPicData uploaded file stream
   */
  receiveCurrentUserProfilePic(receivedPicData: any) {
    //Save the received File
    if (receivedPicData && receivedPicData?.documentFile) {
      this.saveDocumentFile(receivedPicData.documentFile)
      this.userProfileImage = receivedPicData?.documentFile?.documentByte
      this.userProfilePicOperationIcon = environment.assetsImagePath + IconList.EditIcon
    }
    // else {
    //   this.userProfileImage = environment.assetsImagePath + IconList.DefaultUserProfilePic;
    // }
    this.displayDocumentPicDialogue = false;
  }

  /**
   * Saves the currently uploaded file
   * @param documentFileData byte data of file to be uploaded
   */
  saveDocumentFile(documentFileData: any) {
    //Save document (Photo) file
    this.documentService.saveDoucmentFile(documentFileData)
  }
}
